/*eslint-disable  */
import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { OAuth2 } from 'jsforce';

import { getSalesforceToken, parseToken, TokenData } from '../utils/Helpers/DupontSalesforceService';
import { DupontLogger } from '../utils';

interface Props {
  children?: ReactNode;
  onAuthentication?: Function;
  loginUrl?: string;
  clientId: string;
  clientSecret: string;
  redirectUri: string;
}

const useSalesforceSSO = (initOptions: Props) => {
  const Logger = DupontLogger('useSalesforceSSO');
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [tokenData, setTokenData] = useState<TokenData | undefined>(undefined);
  const [refreshInterval, setRefreshInterval] = useState<number | undefined>();

  async function refreshToken(refresh_token: string) {
    const { clientId, clientSecret } = initOptions;
    const getRefreshTokenParam = {
      client_id: clientId,
      client_secret: clientSecret,
      refresh_token,
      grant_type: 'refresh_token',
    };
    Logger.log('refreshToken - Token Expiry time in one minutes: ', getRefreshTokenParam);
    //await getSalesforceToken(getRefreshTokenParam);
  }

  const getAuthTokens = async (grant_type: string) => {
    Logger.log('Salesforce - getAuthTokens: ', grant_type);
    const data = await getSalesforceToken({ ...initOptions, grant_type });
    if (data) {
      setTokenData(data);
      setRefreshInterval(data?.refreshInterval);
    }
    setIsAuthenticating(false);
  };

  useEffect(() => {
    if (refreshInterval && tokenData) {
      setTimeout(() => refreshToken(tokenData?.refreshToken), refreshInterval);
    }
  }, [refreshInterval]);

  useEffect(() => {
    Logger.log('Salesforce useSalesforceSSO - isAuthenticating: ', isAuthenticating);
    const initSSO = () => {
      try {
        if (!window.location.search.includes('code=')) {
          const oAuth2 = new OAuth2(initOptions);
          const redirectUrl = oAuth2.getAuthorizationUrl({});
          window.location.href = redirectUrl;
        } else {
          Logger.log('Salesforce - initSSO, code not present ');
          getAuthTokens('authorization_code');
        }
      } catch (err) {
        Logger.error('initSSO - error: ', err);
        setIsAuthenticating(false);
      }
    };

    const token = process.env.REACT_APP_AUTH_TOKEN;
    if (token) {
      const data = parseToken(token);
      setTokenData(data);
      setIsAuthenticating(false);
    } else if (isAuthenticating) {
      initSSO();
    }
  }, []);

  return { isAuthenticating, tokenData };
};

export default useSalesforceSSO;
